import { observer } from 'mobx-react-lite';
import { createContext } from 'react'
import { HaptikStore } from '../stores/haptick.store';

export const HaptikContext = createContext(new HaptikStore());

export const HaptikContextProvider = observer<any>(({ children, haptikStore }: { children: any; haptikStore: HaptikStore }) => (
  <HaptikContext.Provider value={haptikStore}>{children}</HaptikContext.Provider>
));
